import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {MealKitIconButtonComponent} from '@yoni/mealcomponents-lib';
import {QdmService, Restaurant} from '../../Services/qdm.service';
import {ToastrService} from 'ngx-toastr';
import {Subscription} from 'rxjs';
import { AuthService } from 'app/Services/auth.service';

@Component({
    imports: [MealKitIconButtonComponent],
    selector: 'access-not-authorized-page',
    templateUrl: 'AccessNotAuthorizedPage.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['AccessNotAuthorizedPage.scss']
})

export class AccessNotAuthorizedPageComponent implements OnInit, OnDestroy, AfterViewInit {
  private qdm = inject(QdmService);
  private activatedRoute = inject(ActivatedRoute);
  protected router = inject(Router);
  private toastr = inject(ToastrService);
  private cdr = inject(ChangeDetectorRef);
  private auth = inject(AuthService);


  subscription: Subscription = new Subscription();

  restaurant: Restaurant | undefined;


  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngOnInit() {  
    if(!this.auth.userSubject.value){
      this.router.navigate(["/"]);
      return;
    }
  }

  ngAfterViewInit(): void {
    this.subscription.add(this.activatedRoute.paramMap.subscribe(params => {
      const id = params.get('id');
      this.subscription.add(this.qdm.selectedRestaurant$.subscribe((data) => {
        this.restaurant = data;
        this.cdr.detectChanges();
        if (!this.restaurant) {
          this.router.navigate(["/restaurant", id]);
        }
      }));
    }));

    this.toastr.error("Vous n'êtes pas autorisé à accéder à ce restaurant !", "Accès refusé");
  }

  getRestaurantName(): string {
    return this.restaurant?.name || "Restaurant inconnu";
  }

  logout() {
    this.router.navigate(['/logout'], {queryParams: {restoId: this.restaurant?.id || -1}});
  }
}
